var React = require('react');

function CloseButton (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"32","height":"32","rx":"3.24","fill":"#19222A","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M22.7071 9.29289C22.3166 8.90237 21.6834 8.90237 21.2929 9.29289L16 14.5858L10.7071 9.29289C10.3166 8.90237 9.68342 8.90237 9.29289 9.29289C8.90237 9.68342 8.90237 10.3166 9.29289 10.7071L14.5858 16L9.29289 21.2929C8.90237 21.6834 8.90237 22.3166 9.29289 22.7071C9.68342 23.0976 10.3166 23.0976 10.7071 22.7071L16 17.4142L21.2929 22.7071C21.6834 23.0976 22.3166 23.0976 22.7071 22.7071C23.0976 22.3166 23.0976 21.6834 22.7071 21.2929L17.4142 16L22.7071 10.7071C23.0976 10.3166 23.0976 9.68342 22.7071 9.29289Z","fill":"white","key":1})]);
}

CloseButton.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = CloseButton;

CloseButton.default = CloseButton;
